module.exports = __webpack_public_path__ + "static/media/header-invoice.51653434.svg";